import format from 'date-fns/format'
import { useAppSelector } from '@user/store/hooks'
import { externalProductPestPacName } from '@sales-center/common'
import { selectCurrentUser } from '@user/store/authorization'

export function useGetScheduleLink(techId: string, startDate: Date) {
  const { externalProduct, clientUrl } = useAppSelector(selectCurrentUser)

  switch (externalProduct) {
    case externalProductPestPacName: {
      const dateStr = format(startDate, 'dd/MM/yyyy')
      return `${clientUrl}/appointment/default.asp?TechID1=${techId}&StartDate=${dateStr}`
    }
    default:
      return undefined
  }
}
